import { createSelector } from 'reselect';
import path from 'ramda/es/path';


const selectIsDnevnik = createSelector(
  [
    (state, { studentId }) => path(['students', 'data', studentId], state),
    (state, { studentId }) => path(['eljur', 'user', 'result', 'relations', 'students', studentId], state),
  ],
  (internalStudent, externalStudent) => (
    (internalStudent && internalStudent.hasDnevnik) || !!externalStudent
  )
);

export default selectIsDnevnik;
